
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import {AuthTokens, User, ValidationError} from '../../models/auth.models';


export interface AuthState {
  user: User | null;
  tokens: AuthTokens | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  validationErrors: ValidationError[];
}

export function createInitialState(): AuthState {
  return {
    user: null,
    tokens: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    validationErrors: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auth', resettable: true })
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialState());
  }

  login(user: User, tokens: AuthTokens) {
    this.update({
      user,
      tokens,
      isAuthenticated: true,
      loading: false,
      error: null,
      validationErrors: []
    });
  }

  logout() {
    this.update(createInitialState());
  }

  setAuthLoading(loading: boolean) {
    this.update({ loading });
  }

  setAuthError(error: string | null, validationErrors: ValidationError[] = []) {
    this.update({ error, validationErrors, loading: false });
  }

  clearErrors() {
    this.update({ error: null, validationErrors: [] });
  }

  updateTokens(tokens: AuthTokens) {
    this.update({ tokens });
  }

  updateUser(user: User) {
    this.update({ user });
  }
}
